import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { Cart2CashierQuery, Cart2CashierVo } from './type';

/**
 * 购物车下单收银台
  POST /api/order/cart/cashier
  接口ID：234956488
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-234956488
 */
export const postCart2Cashier = (data: Cart2CashierQuery): AxiosPromise<Cart2CashierVo> => {
  return request({
    url: '/api/order/buyer/cart/cashier',
    method: 'post',
    data
  });
};
